import { Trie } from '@wry/trie';
import { canUseWeakMap } from "../../utilities/index.js";
import { QueryReference } from "./QueryReference.js";
var SuspenseCache = (function () {
    function SuspenseCache(options) {
        if (options === void 0) { options = Object.create(null); }
        this.cacheKeys = new Trie(canUseWeakMap, function (cacheKey) { return cacheKey; });
        this.queryRefs = new Map();
        this.options = options;
    }
    SuspenseCache.prototype.getQueryRef = function (cacheKey, createObservable) {
        var _this = this;
        var stableCacheKey = this.cacheKeys.lookupArray(cacheKey);
        if (!this.queryRefs.has(stableCacheKey)) {
            this.queryRefs.set(stableCacheKey, new QueryReference(createObservable(), {
                key: stableCacheKey,
                autoDisposeTimeoutMs: this.options.autoDisposeTimeoutMs,
                onDispose: function () { return _this.queryRefs.delete(stableCacheKey); },
            }));
        }
        return this.queryRefs.get(stableCacheKey);
    };
    return SuspenseCache;
}());
export { SuspenseCache };
//# sourceMappingURL=SuspenseCache.js.map